import React, { useState } from "react";
import { usersAPI } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

// First login after the SRM set the password: the user picks their own
// before anything else opens.
const ChangePassword = () => {
    const { user, refreshUser, logout } = useAuth();
    const [pw, setPw] = useState("");
    const [pw2, setPw2] = useState("");
    const [saving, setSaving] = useState(false);

    const save = async (e) => {
        e.preventDefault();
        if (pw.length < 8) return toast.error("Use at least 8 characters");
        if (pw !== pw2) return toast.error("The two passwords don't match");
        setSaving(true);
        try {
            await usersAPI.updateProfile({ password: pw });
            await refreshUser();
            toast.success("Password changed");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Couldn't change the password");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-background p-4">
            <Card className="w-full max-w-md border-border/40 bg-card">
                <CardContent className="space-y-5 p-6">
                    <div className="space-y-1">
                        <h1 className="flex items-center gap-2 font-heading text-2xl font-bold">
                            <KeyRound className="h-6 w-6 text-yellow-500" /> Choose your password
                        </h1>
                        <p className="text-sm text-muted-foreground">
                            Welcome{user?.name ? `, ${user.name}` : ""}. The password you were given is temporary — set your own to continue.
                        </p>
                    </div>
                    <form onSubmit={save} className="space-y-4">
                        <div className="space-y-1.5">
                            <Label htmlFor="pw">New password</Label>
                            <Input id="pw" type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} />
                            <p className="text-xs text-muted-foreground">At least 8 characters.</p>
                        </div>
                        <div className="space-y-1.5">
                            <Label htmlFor="pw2">Repeat it</Label>
                            <Input id="pw2" type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} />
                        </div>
                        <div className="flex items-center gap-2">
                            <Button type="submit" className="flex-1 gap-2" disabled={saving}>
                                {saving && <Loader2 className="h-4 w-4 animate-spin" />}
                                Save and continue
                            </Button>
                            <Button type="button" variant="ghost" onClick={logout}>
                                Sign out
                            </Button>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
};

export default ChangePassword;
